// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"320":"4c04f5d4","597":"d91eeab7","839":"de8f2fb8"}[chunkId] + ".chunk.css";
};